export default __webpack_public_path__ + "static/media/mobile-download-qr.26f30cc5.svg";